import { MapPin, Clock, Award, Facebook, Instagram, Linkedin, ShieldCheck, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICE_AREAS } from "@/data/siteData";

const Row = ({ Icon, label, children, testId }) => (
  <div data-testid={testId} className="flex items-start gap-4 border-b border-border py-5 last:border-0">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary text-primary">
      <Icon className="h-4 w-4" strokeWidth={1.75} />
    </span>
    <div>
      <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
      <div className="mt-1 text-base text-foreground">{children}</div>
    </div>
  </div>
);

export const ContactInfo = () => (
  <aside data-testid="contact-info-card" className="rounded-2xl border border-border bg-secondary/50 p-8">
    <Row Icon={Clock} label="Response time" testId="contact-info-response">Typically within one business day</Row>
    <Row Icon={Award} label="Credentials" testId="contact-info-credentials">NABCEP Licensed &middot; Certified manufacturer service partner</Row>
    <Row Icon={MapPin} label="Based in" testId="contact-info-location">{COMPANY.location}</Row>
    <Row Icon={MapPin} label="Service Areas" testId="contact-info-areas">
      <span className="text-sm text-foreground/80">{SERVICE_AREAS.join(" · ")}</span>
    </Row>

    <a
      href={COMPANY.bbbUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contact-bbb-link"
      className="mt-6 flex items-center gap-3 rounded-xl border border-accent/50 bg-background p-4 transition-colors hover:border-accent"
    >
      <ShieldCheck className="h-8 w-8 text-accent" strokeWidth={1.25} />
      <span className="flex-1 text-sm">
        <span className="block font-medium text-foreground">BBB Accredited &middot; A Rating</span>
        <span className="block text-muted-foreground">Verify our business profile and reviews</span>
      </span>
      <ArrowUpRight className="h-4 w-4 text-muted-foreground" />
    </a>

    <div className="mt-8">
      <p className="eyebrow text-primary">Follow our work</p>
      <div className="mt-4 flex gap-3">
        {[
          [COMPANY.socials.facebook, Facebook, "Facebook", "contact-facebook-link"],
          [COMPANY.socials.instagram, Instagram, "Instagram", "contact-instagram-link"],
          [COMPANY.socials.linkedin, Linkedin, "LinkedIn", "contact-linkedin-link"],
        ].map(([href, Icon, label, id]) => (
          <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={id} className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background text-primary transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 hover:bg-primary hover:text-white">
            <Icon className="h-4 w-4" strokeWidth={1.75} />
          </a>
        ))}
      </div>
    </div>
  </aside>
);
